<div class="seat-layout">
  <div *ngFor="let layout of deckLayouts ;let floorIdx = index">
    <div class="p-g-{{12/deckLayouts.length}}">
      <h2 style="text-align:center; font-size: 14px;">{{layout.deckName}}</h2>
      <div class='fsp-root-div' [ngStyle]="{width: '300px', height: '460px'}">
        <div class="fsp-seat"
          [ngStyle]="{left: layout.driverX +'px', top: layout.driverY +'px',width: layout.driverWidth +'px', height: layout.driverHeight + 'px'}">
          <div class="sprite driver"></div>
        </div>
        <app-seat-layout (availableSeat)="onEmptySeatInDeck($event)" (bookedSeat)="onBookedSeat($event)"
          [interactive]="interactive" [seatLayouts]='layout.deckSeats' [orientation]='orientation'
          [deckWidth]=' layout.width' [deckHeight]=' layout.height'></app-seat-layout>
      </div>
    </div>
  </div>
</div>
